const API_BASE_URL = "https://dynamic-reg-validation-service-51hl.onrender.com/api";

export const validateUser = async (data) => {
  console.log("📤 Sending Data to Backend:", data); // Debugging Log

  try {
    const response = await fetch(`${API_BASE_URL}/validate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      let errorMessage = `Server error: ${response.status}`;
      try {
        const errorData = await response.json(); // ✅ Try parsing error as JSON
        errorMessage = errorData.error || errorMessage;
      } catch {
        const errorText = await response.text(); // ✅ Fallback to text
        errorMessage = errorText || errorMessage;
      }
      console.error("❌ API Request Failed:", errorMessage);
      return { error: errorMessage };
    }

    const result = await response.json();
    console.log("📥 Response from Backend:", result); // Debugging Log
    return result;
  } catch (error) {
    console.error("❌ Error during validation:", error);
    return { error: "An error occurred during validation." };
  }
};
